module.exports = __webpack_public_path__ + "img/protab.ce68ec3b.png";